import { Folder } from '@/api/generatedApi';
import { MoveFolderModal } from '@/components/modals/MoveFolderModal/MoveFolderModal';
import { useGetCurrentUser } from '@/hooks/api/users/useGetCurrentUser';
import DriveFileMoveIcon from '@mui/icons-material/DriveFileMove';
import { IconButton, IconButtonProps, Tooltip } from '@mui/material';
import { useState } from 'react';

export const MoveFolderButton = ({ folder, size = 'small' }: { folder: Folder; size?: IconButtonProps['size'] }) => {
  const { permissions } = useGetCurrentUser();
  const [isModalOpen, setIsModalOpen] = useState(false);

  if (!permissions.canCreateFolders) {
    return;
  }

  const handleClick = (event: React.MouseEvent) => {
    event.stopPropagation();
    setIsModalOpen(true);
  };

  return (
    <>
      <Tooltip title='Move folder'>
        <IconButton onClick={handleClick} size={size} sx={{ color: 'success.main' }}>
          <DriveFileMoveIcon sx={{ fontSize: '22px' }} />
        </IconButton>
      </Tooltip>
      <MoveFolderModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} folder={folder} />
    </>
  );
};
